<div class="login-page">

    <blitz-login [showModal]="true" (close)="close()" [displayPage]="true" ></blitz-login>
    
</div>